import {
  WorkspaceFormDialog,
  type WorkspaceFormValues,
} from "@/action-dialog/dialogs/WorkspaceFormDialog";
import { createCallable } from "react-call";
import { useMutationFlow, type MutationFn } from "react-call/mutation-flow";

const UNMOUNTING_DELAY_MS = 200;

export type CreateWorkspaceCallableProps = {
  mutationFn?: MutationFn<boolean, WorkspaceFormValues>;
};

export const CreateWorkspaceCallable = createCallable<
  CreateWorkspaceCallableProps,
  boolean
>(({ call, mutationFn }) => {
  const submit = useMutationFlow(call, mutationFn);
  const pending = submit.pending;

  return (
    <WorkspaceFormDialog
      open
      title="New workspace"
      submitLabel="Create"
      pendingLabel="Creating…"
      alwaysAllowSubmit
      isPending={pending}
      onClose={() => {
        if (!pending) {
          call.end(false);
        }
      }}
      onSubmit={(values) => submit(values).orEnd(true)}
    />
  );
}, UNMOUNTING_DELAY_MS);

CreateWorkspaceCallable.displayName = "CreateWorkspaceCallable";
